import { DropdownItem as BTDropdownItem } from "reactstrap";
import classNames from "classnames";
import styles from "./PriceInput/index.module.scss";
import { ReactComponent as IconCheckmark } from "../assets/ic-checkmark.svg";

const DropdownItem = ({
  onClick,
  name,
  isSelected,
  checkmarkClassName,
  labelClassName,
  children,
  disabled,
}) => (
  <BTDropdownItem
    disabled={disabled}
    onClick={onClick}
    className={classNames(
      "position-relative w-100",
      isSelected && "selected",
      disabled && "opacity-50",
    )}
  >
    <div className={classNames("text-truncate text-primary", labelClassName)}>
      {name || children}
    </div>
    {isSelected && (
      <IconCheckmark
        className={classNames(
          "position-absolute",
          styles.checkmark,
          checkmarkClassName,
        )}
      />
    )}
  </BTDropdownItem>
);
export default DropdownItem;
